import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { useCallback, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import PrimeDialog from "../../../../components/dialog/PrimeDialog";
import { FormInput } from "../../../../components/FormInput";
import { FormInputFile } from "../../../../components/FormInputFile";
import { FormInputSearch } from "../../../../components/FormInputSearch";
import FormNumberInput from "../../../../components/FormNumberInput";
import { FormTextarea } from "../../../../components/FormTextarea";
import ImagePDFComponent from "../../../../components/ImagePDFComponent";
import { AlertService } from "../../../../utility/service/alert-service";
import { F1050317Before } from "../../../../utility/service/carbonFootprint-service";
import {
  checkDpSuccess,
  getFileBase64,
  splitFileExtension,
  splitFileName,
} from "../../../../utility/service/tool-service";
import NumberUtil from "../../../../utility/NumberUtil";
import { addFormValidator } from "../../../../utility/validate/formValidator";
import CarbonCoefficientComponent from "../CarbonCoefficientComponent";
import FiveRatingForm from "../FiveRatingForm";

const AddNewActivity = ({
  register,
  errors,
  control,
  editAction,
  setValue,
  currentObj,
  getValues,
  stage,
  unitCodeList,
  groupCodeList,
  distributionPrincipleList,
  fileInputRef,
  watch,
  isEditable,
}) => {
  const { t } = useTranslation();
  const { itemObj } = useOutletContext() || {};
  const [previewUrl, setPreviewUrl] = useState(null);
  const [zoomSrc, setZoomSrc] = useState(null);
  const [fileInfo, setFileInfo] = useState({});
  const [showIndex, setShowIndex] = useState(false);
  const [pickName, setPickName] = useState("");
  const [formRule, setFormRule] = useState([]); //表單驗證
  const [unitQuantity, setUnitQuantity] = useState("");

  const totalProduction = itemObj?.quantity;

  const parseNumber = (value) => {
    if (value === undefined || value === null || value === "") return null;
    const parsed = parseFloat(NumberUtil.toStandardFormat(value));
    return isNaN(parsed) ? null : parsed;
  };

  const shouldSkipConversion = (value) => {
    if (value === "" || value === undefined || value === null) return false;
    const std = NumberUtil.toStandardFormat(String(value));
    return std.endsWith(".") || std === "-";
  };

  const formatCalculatedValue = (value) => {
    if (value === null || value === undefined || isNaN(value)) return "";
    return NumberUtil.toStandardFormat(String(value));
  };

  const calcUnitQuantityFromDataValue = (dataValue) => {
    const total = parseNumber(totalProduction);
    const data = parseNumber(dataValue);
    if (!total || data === null) return "";
    return formatCalculatedValue(data / total);
  };

  const calcDataValueFromUnitQuantity = (unitValue) => {
    const total = parseNumber(totalProduction);
    const unit = parseNumber(unitValue);
    if (!total || unit === null) return "";
    return formatCalculatedValue(unit * total);
  };

  const handleDataValueChange = (newValue) => {
    setValue("dataValue", newValue, { shouldValidate: true });
    if (!shouldSkipConversion(newValue)) {
      setUnitQuantity(calcUnitQuantityFromDataValue(newValue));
    }
  };

  const handleUnitQuantityChange = (newValue) => {
    setUnitQuantity(newValue);
    if (shouldSkipConversion(newValue)) return;
    const dataValue = calcDataValueFromUnitQuantity(newValue);
    if (dataValue !== "") {
      setValue("dataValue", dataValue, { shouldValidate: true });
    } else if (newValue === "") {
      setValue("dataValue", "", { shouldValidate: true });
    }
  };

  const inputCheckKeyDown = (e) => {
    //避免觸發 按enter 後 就觸發 onSubmit 事件冒泡 給input 使用 <FormInput enterClick事件 ; 一般input onKeyDown事件
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const btnSerchTransCarbon = () => {
    setValue("keywordSearch", "");
    setShowIndex(true);
    setPickName("transportationEmissionCoefficient");
  };

  const btnSerchEmissionName = () => {
    // 如果 coefName 有值，則將其帶入 keywordSearch 作為查詢條件
    const currentCoefName = getValues("coefName");
    setValue("keywordSearch", currentCoefName || "");
    setShowIndex(true);
    setPickName("coefName");
  };

  const handlePickData = (rowData) => {
    setShowIndex(false);
    setValue(pickName, rowData?.coefficientName, { shouldValidate: true });
    if (pickName === "coefName") {
      //先帶入排放係數相關欄位 運輸碳係數先pass
      setValue("coefValue", rowData?.carbonFootprintValue, { shouldValidate: true });
      setValue("coefUnit", rowData?.declareUnit, { shouldValidate: true });
    }
    setValue("keywordSearch", "");
  };
  useEffect(() => {
    axios_getCreateBefore();
  }, []);

  useEffect(() => {
    if (editAction === "add") {
      setUnitQuantity("");
      return;
    }
    if (!currentObj?.carbonDataId) return;

    const syncFromDataValue = () => {
      const current = getValues("dataValue");
      if (current) {
        setUnitQuantity(calcUnitQuantityFromDataValue(current));
      }
    };

    syncFromDataValue();
    const timer = setTimeout(syncFromDataValue, 300);
    return () => clearTimeout(timer);
  }, [currentObj?.carbonDataId, editAction]);

  useEffect(() => {
    if (editAction === "edit") {
      setValue("");
      if (currentObj?.fileExtension !== null) {
        setZoomSrc(currentObj?.filePath); //原圖
        if (currentObj?.fileExtension === "pdf") {
          setPreviewUrl(currentObj?.filePath); //原圖
        } else {
          setPreviewUrl(currentObj?.filePathSml); //縮圖
        }
        setFileInfo({
          type: currentObj?.fileExtension,
          name: `${currentObj?.fileName}.${currentObj?.fileExtension}`,
        });
      }
    }
  }, [editAction]);

  const handleFileChange = (e) => {
    //每次開啟選擇檔案觸發onChange事件
    if (e.target.files[0]) {
      if (e.target.files[0].size >= 20000000) {
        AlertService.ok("Error", "Size over 20MB");
        setPreviewUrl(null);
        setZoomSrc(null);
        setValue("fileExtension", ""); //副檔名
        setValue("fileName", ""); //檔名
        setValue("filePic", "");
        setFileInfo({});
        fileInputRef.current.value = null;
      } else {
        setPreviewUrl(URL.createObjectURL(e.target.files[0]));
        setZoomSrc(URL.createObjectURL(e.target.files[0]));

        let fileExtension = splitFileExtension(e.target.files[0]?.name);
        setValue("fileExtension", fileExtension); //副檔名
        setValue("fileName", splitFileName(e.target.files[0]?.name));
        setFileInfo(e.target.files[0]);

        // 測試用 ↓
        getFileBase64(e.target.files[0]).then((result) => {
          setValue("filePathSml", result);
          setValue("filePath", result);
        });
        // 測試用 ↑

        setValue("filePic", e.target.files[0], { shouldValidate: true }); //檔案格式 原圖 如果轉為MulitPart 需解開此
      }
    }
  };

  const handleDeleteImg = () => {
    //刪除圖片
    if (fileInputRef?.current?.value !== undefined) {
      fileInputRef.current.value = null;
      setPreviewUrl(null);
      setZoomSrc(null);
      setValue("fileExtension", ""); //副檔名
      setValue("fileName", ""); //檔名
      setValue("filePic", "");

      // 測試用 要記得刪除 ↓
      setValue("filePathSml", "");
      setValue("filePath", "");
      // 測試用 要記得刪除 ↑
    }
  };

  // F1050317Before
  //建立前查詢form 規則
  const axios_getCreateBefore = () => {
    F1050317Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };
  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule]
  );

  const totalProductionDisplay = totalProduction
    ? `${NumberUtil.formatWithCommas(totalProduction)}${itemObj?.declaringUnitName ? ` ${itemObj.declaringUnitName}` : ""}`
    : "-";

  return (
    <>
      {/* 規則載入後再render畫面 */}
      {formRule?.length > 0 && (
        <form className="grid">
          <div className="col-12">
            <label className="font-semibold">{t("activity_data")}</label>
          </div>
          {/* 名稱 */}
          <div className="col-12 lg:col-8">
            <FormInput
              register={register}
              errors={errors}
              id="dataName"
              name="dataName"
              type="text"
              labelText={t("productName")}
              labelClass="required"
              rules={setValidForm("dataName")}
              disabled={!isEditable}
            />
          </div>
          {/* 群組 */}
          <div className="col-12 lg:col-4">
            <label htmlFor="dataGroup" className="form-label required">
              {t("group")}
            </label>
            <Controller
              name="dataGroup"
              control={control}
              rules={setValidForm("dataGroup")}
              render={({ field, fieldState }) => (
                <Dropdown
                  filter
                  optionLabel="subitemName"
                  optionValue="subitemNo"
                  disabled={!isEditable}
                  appendTo={"self"}
                  value={field.value}
                  virtualScrollerOptions={{ itemSize: 40 }}
                  defaultValue={""}
                  placeholder={t("plz_chs")}
                  name="dataGroup"
                  control={control}
                  options={groupCodeList}
                  className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                  onChange={(event) => {
                    field.onChange(event.value);
                  }}
                />
              )}
            />
          </div>
          <div className="col-12 text-sm text-color-secondary">
            {t("activityDataConversionHint", { totalQuantity: totalProductionDisplay })}
          </div>
          {/* 活動數據總量 */}
          <div className="col-12 lg:col-3">
            <FormNumberInput
              labelClass="required"
              withLabel={true}
              register={register}
              errors={errors}
              id="dataValue"
              labelText={t("activityDataTotal")}
              step="any"
              disabled={!isEditable || !totalProduction}
              enterClick={inputCheckKeyDown}
              rules={setValidForm("dataValue")}
              value={watch("dataValue")}
              onChange={handleDataValueChange}
            />
          </div>
          {/* 每單位使用量 */}
          <div className="col-12 lg:col-3">
            <label htmlFor="unitQuantityDisplay" className="form-label">
              {t("perUnitUsage")}
            </label>
            <FormNumberInput
              withLabel={false}
              id="unitQuantityDisplay"
              className="w-full"
              step="any"
              disabled={!isEditable || !totalProduction}
              enterClick={inputCheckKeyDown}
              value={unitQuantity}
              onChange={handleUnitQuantityChange}
            />
          </div>
          {/* 單位 */}
          <div className="col-12 lg:col-3">
            <label htmlFor="dataUnit" className="form-label required">
              {t("unit")}
            </label>
            <Controller
              name="dataUnit"
              control={control}
              rules={setValidForm("dataUnit")}
              render={({ field, fieldState }) => (
                <Dropdown
                  filter
                  optionLabel="subitemName"
                  optionValue="subitemNo"
                  disabled={!isEditable}
                  appendTo={"self"}
                  value={field.value}
                  virtualScrollerOptions={{ itemSize: 40 }}
                  defaultValue={""}
                  placeholder={t("plz_chs")}
                  control={control}
                  options={unitCodeList}
                  className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                  onChange={(event) => {
                    field.onChange(event.value);
                  }}
                />
              )}
            />
          </div>
          <div className="col-12 lg:col-3"></div>
          {/* 分配比例 */}
          <div className="col-12 lg:col-3">
            <FormNumberInput
              labelClass=""
              withLabel={true}
              register={register}
              errors={errors}
              id="distributionRatio"
              labelText={`${t("allocationRatio")}(%)`}
              disabled={!isEditable}
              enterClick={inputCheckKeyDown}
              value={watch("distributionRatio")}
              onChange={(newValue) => setValue("distributionRatio", newValue)}
            />
          </div>
          {/* 分配原因 */}
          <div className="col-12 lg:col-3">
            <label htmlFor="distributionReason" className="form-label">
              {t("allocationPrinciples")}
            </label>
            <Controller
              name="distributionReason"
              control={control}
              render={({ field, fieldState }) => (
                <Dropdown
                  filter
                  optionLabel="subitemName"
                  optionValue="subitemNo"
                  disabled={!isEditable}
                  appendTo={"self"}
                  value={field.value}
                  virtualScrollerOptions={{ itemSize: 40 }}
                  defaultValue={""}
                  placeholder={t("plz_chs")}
                  name="distributionReason"
                  control={control}
                  options={distributionPrincipleList}
                  className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                  onChange={(event) => {
                    field.onChange(event.value);
                  }}
                />
              )}
            />
          </div>
          <div className="col-12 lg:col-3"></div>
          <div className="col-12 lg:col-3"></div>
          {/* 供應商地址 */}
          <div className="col-12 lg:col-6">
            <FormInput
              withLabel={true}
              register={register}
              errors={errors}
              id="supplierAddress"
              labelText={t("supplierAddress")}
              type="text"
              disabled={!isEditable}
              enterClick={inputCheckKeyDown}
            />
          </div>
          {/* 活動數據來源 */}
          <div className="col-12 lg:col-6">
            <FormInput
              labelClass="required"
              withLabel={true}
              register={register}
              errors={errors}
              id="dataSource"
              name="dataSource"
              labelText={t("dataDenerator")}
              type="text"
              disabled={!isEditable}
              enterClick={inputCheckKeyDown}
              rules={setValidForm("dataSource")}
            />
          </div>
          {/* 運輸方式 */}
          {/* <div className="col-12 lg:col-4">
            <label
                htmlFor="transportationMethod"
                className="form-label">
                {`運輸方式`}
            </label>
            <Controller
                name="transportationMethod"
                control={control}
                rules={{ required: { value: false, message: t('validation.required') } }}
                render={({ field, fieldState }) => (
                    <Dropdown
                    filter
                    disabled={!isEditable}
                    appendTo={"self"}
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="transportationMethod"
                    control={control}
                    options={["陸運","海運","空運","管線","其他","無"]}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                        field.onChange(event.value);
                    }}
                    />
                )}
                />
    
            </div> */}
          {/* 運輸距離 */}
          {/* <div className="col-12 lg:col-4">
                <FormInput
                    withLabel={true}
                    register={register}
                    errors={errors}
                    id="transportationDistance"
                    labelText={`運輸距離`}
                    type="number"
                    disabled={!isEditable}
                    enterClick={inputCheckKeyDown}     
                />
            </div> */}
          {/* 運輸距離單位 */}
          {/* <div className="col-12 lg:col-4">
            <label
                htmlFor="transportationDistanceUnit"
                className="form-label">
                {`運輸距離單位`}
            </label>
            <Controller
                name="transportationDistanceUnit"
                control={control}
                rules={{ required: { value: false, message: t('validation.required') } }}
                render={({ field, fieldState }) => (
                    <Dropdown
                    filter
                    // optionLabel='subitemName'
                    // optionValue='subitemNo'
                    disabled={!isEditable}
                    appendTo={"self"}
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="transportationDistanceUnit"
                    control={control}
                    options={["公尺(m)","公里(km)","海浬(nm)","延人公里(pkm)","延噸公里(tkm)","無"]}
                    // options={unitCodeList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                        field.onChange(event.value);
                    }}
                    />
                )}
                />
            </div> */}
          {/* 運輸碳係數 */}
          {/* <div className="col-12 lg:col-12">
                <FormInputSearch
                    disabled={!isEditable}
                    register={register}
                    errors={errors}
                    id="transportationEmissionCoefficient"
                    labelText={`運輸碳係數`}
                    type="text"
                    labelClass="control-label"
                    rules={{}}
                    btnSerch={btnSerchTransCarbon}
                    />
            </div> */}
          <div className="col-12">
            <label className="font-semibold">{t("emissionFactor")}</label>
          </div>
          {/* 排放係數 名稱 */}
          <div className="col-12 lg:col-3">
            <FormInputSearch
              register={register}
              errors={errors}
              id="coefName"
              name="coefName"
              type="text"
              labelText={t("productName")}
              labelClass=""
              btnSerch={btnSerchEmissionName}
              disabled={!isEditable}
            />
          </div>
          {/* 排放係數 數值 */}
          <div className="col-12 lg:col-3">
            <FormNumberInput
              register={register}
              errors={errors}
              id="coefValue"
              name="coefValue"
              labelText={t("carbonFootprintValue")}
              labelClass=""
              value={watch("coefValue")}
              onChange={(newValue) => setValue("coefValue", newValue)}
              disabled={!isEditable}
            />
          </div>
          <div className="col-12 lg:col-3">
            {/* 單位 */}
            <label htmlFor="coefUnit" className="form-label">
              {t("unit")}
            </label>
            <Controller
              name="coefUnit"
              control={control}
              // rules={{ required: { value: false, message: t('validation.required') } }}
              render={({ field, fieldState }) => (
                <Dropdown
                  filter
                  optionLabel="subitemName"
                  optionValue="subitemNo"
                  disabled={!isEditable}
                  appendTo={"self"}
                  value={field.value}
                  virtualScrollerOptions={{ itemSize: 40 }}
                  defaultValue={""}
                  placeholder={t("plz_chs")}
                  name="coefUnit"
                  control={control}
                  options={unitCodeList}
                  // options={["公斤(kg)","毫米(mm)","公分(cm)","公尺(m)","公里(km)","海浬(nm)","英寸(in)","碼(yard)","毫克(mg)","公克(g)","毫升","度(kwh)"]}
                  className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                  onChange={(event) => {
                    field.onChange(event.value);
                  }}
                />
              )}
            />
          </div>
          {/* 轉換比例 - 只有當數據單位與係數單位不同時才顯示 */}
          {watch("dataUnit") && watch("coefUnit") && watch("dataUnit") !== watch("coefUnit") && (
            <div className="col-12 lg:col-3">
              <FormNumberInput
                labelClass=""
                withLabel={true}
                register={register}
                errors={errors}
                id="unitRatio"
                labelText={t("conversionRatio")}
                disabled={!isEditable}
                enterClick={inputCheckKeyDown}
                value={watch("unitRatio")}
                onChange={(newValue) => setValue("unitRatio", newValue)}
                placeholder={`1${unitCodeList.find((unit) => unit.subitemNo === watch("dataUnit"))?.subitemName ||
                  watch("dataUnit")} ＝ ? ${unitCodeList.find((unit) => unit.subitemNo === watch("coefUnit"))
                  ?.subitemName || watch("coefUnit")}`}
              />
              {/* 當有轉換比例值時顯示實際轉換關係 */}
              {watch("unitRatio") && watch("unitRatio") !== "" && (
                <div className="text-xs text-blue-600 mt-1 font-medium">
                  1{" "}
                  {unitCodeList.find((unit) => unit.subitemNo === watch("dataUnit"))?.subitemName || watch("dataUnit")}{" "}
                  ＝ {watch("unitRatio")}{" "}
                  {unitCodeList.find((unit) => unit.subitemNo === watch("coefUnit"))?.subitemName || watch("coefUnit")}
                </div>
              )}
            </div>
          )}
          {/* 數據來源 */}
          <div className="col-12 lg:col-12">
            <FormInput
              disabled={!isEditable}
              register={register}
              errors={errors}
              id="coefSource"
              labelText={t("data_Source")}
              type="text"
              labelClass="control-label"
              rules={{}}
            />
          </div>

          {/* 備註 */}
          <div className="col-12 lg:col-6">
            <FormTextarea
              register={register}
              errors={errors}
              id="comment"
              name="comment"
              type="text"
              labelText={t("remark")}
              areaClass="w-full"
              disabled={!isEditable}
            />
          </div>

          <div className="col-12 lg:col-6">
            <FormInputFile
              register={register}
              errors={errors}
              acceptFileType=".jpg,.png"
              id="filePic"
              name="filePic"
              limitSize="20MB"
              fileChange={(e) => {
                handleFileChange(e);
              }}
              fileInputRef={fileInputRef}
              disabled={!isEditable}
            />
          </div>
          {/* 數據品質 */}
          <div className="col-12 lg:col-2">
            <ImagePDFComponent
              wrapperClass=""
              file={fileInfo}
              previewUrl={previewUrl}
              zoomSrc={zoomSrc}
              disabled={!isEditable}
              imgWidth="150"
              imgHeight="150"
              deleteImg={handleDeleteImg}
            />
          </div>
          <FiveRatingForm
            control={control}
            register={register}
            errors={errors}
            editAction={editAction}
            isEditable={isEditable}
          />

          <PrimeDialog
            scrollByBody={true}
            visible={showIndex}
            isShowConfBtn={false}
            onClose={() => {
              setShowIndex(false);
            }}
            onConfirm={() => {}}
            title={t("coefficient")}
            size="lg"
            bodyTemplate={
              <CarbonCoefficientComponent
                getValues={getValues}
                register={register}
                errors={errors}
                setPickDialog={setShowIndex}
                pickData={handlePickData}
              />
            }
          />
        </form>
      )}
    </>
  );
};

export default AddNewActivity;
